'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Grid from '../components/hotstuff/Grid'
import Slideshow from '../fx/Slideshow'
import Channels from '../base/channels'
import RegisterMail from '../components/RegisterMail'
import FlowWaypoints from '../fx/FlowWaypoints'
import StickyContent from '../fx/StickyContent'
import Players from '../components/PlayerYT'
import GridAccordion from '../fx/Accordion'
import InstantBuy from '../components/InstantBuy'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--singleNews'
        this.$slideshow = this.view.querySelector('.jsSlideshow--view')
        // Objects
        this.raf = undefined
        this.grids = []
        this.accordions = []
        // Fns
        this.players = new Players(this.view)
        this.accordion()
        this.events()
        this.makeGrids()
        if(this.$slideshow != null) {
            this.slideshow = new Slideshow(this.$slideshow)
        }
        this.moodletter = new RegisterMail(this.view.querySelector('.jsRegister--footer'))
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    accordion()
    {
        const $items = this.view.querySelectorAll('.jsAccordion--item');
        if($items.length)
        {
            for(let i = 0; i < $items.length; i++ ) {
                const $item = $items[i]
                let instance =  new GridAccordion($item)
                instance.setup()
                this.accordions.push(instance)
            }
        }
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        for(let i = 0; i < this.grids.length; i++) {
            const instanceGrid = this.grids[i]
            instanceGrid.destroy()
        }
        if(typeof this.slideshow != 'undefined') {
            this.slideshow.destroy()
        }
        this.waypoints.destroy()
        this.players.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
        Env.framework.UI.listenTransitionUpdateBg(this.view)
        Env.framework.UI.listenPopinTrigger(this.view)
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
        setTimeout(() => {
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
        Env.framework.UI.lazy()
        Env.framework.UI.pinRefresh()
        Env.framework.UI.lazy()
        this.sticky = new StickyContent(this.view)
        this.instantBuy = new InstantBuy(this.view)
    }

    intro()
    {
        const tl = new TimelineLite()
        let $brand = this.view.querySelector('.jsBrand')
        const $intro = this.view.querySelector('.jsIntro')
        const $content = this.view.querySelector('.jsContent')

        if($intro !== null) {
            $brand.classList.remove('jsBrand')
            $brand = $intro
        }
        tl.add([
            TweenLite.fromTo($brand , .8 , { opacity : 0 , y : 15 } , { opacity : 1 , y : 0 , ease : Power3.easeOut }),
            TweenLite.fromTo($content , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 }),
        ])
        tl.add(()=>{
            TweenLite.set($content , { clearProps : "y" })
        })
    }

    makeGrids()
    {
        const $items = this.view.querySelectorAll('.jsIsotope--view')
        for(let i = 0; i < $items.length; i++) {
            const $item = $items[i]
            const instance = new Grid($item)
            instance.setup()
            this.grids.push(instance)
        }
    }

}

page = Barba.BaseView.extend({
    namespace: 'singleNews',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;